/* eslint-disable no-use-before-define */
import { RootState } from '..';
import { Optional } from '../../common/miscUtils.types';

const nameAction = <N extends string>(name: N) => `dataStorageNew//${name}` as const;

// eslint-disable-next-line no-use-before-define
export const setDataStorageNew = (data: Partial<DataStorageCustomDataType>) => {
  return {
    type: nameAction('SET_DATA_STORAGE_NEW'),
    payload: data,
  } as const;
};

export const resetDataStorageNew = () => {
  return {
    type: nameAction('RESET_DATA_STORAGE_NEW'),
  } as const;
};

export const selectDataStorage = (state: RootState) => {
  return state.dataStorageNew;
};

export const selectQuoteIdFromDataStorage = (state: RootState) => {
  return state.dataStorageNew.quoteId;
};

export const selectCreditApplicationIdFromDataStorage = (state: RootState) => {
  return state.dataStorageNew.creditApplicationId;
};

export const selectCreditApplicationStakeholdersFromDataStorage = (state: RootState) => {
  return state.dataStorageNew.creditApplicationStakeholders;
};

export const selectMilesCustomerIdFromDataStorage = (state: RootState) => {
  return state.dataStorageNew.milesCustomerId;
};

export const selectSaveAndContinueMobilePhoneNumber = (state: RootState) => {
  return state.dataStorageNew.saveAndContinueMobilePhoneNumber;
};

export const selectSaveAndContinueData = (state: RootState) => ({
  email: state.dataStorageNew.saveAndContinueEmail,
  phoneCountryCode: state.dataStorageNew.saveAndContinueMobilePhoneCountryCode,
  phoneNumber: state.dataStorageNew.saveAndContinueMobilePhoneNumber,
});

export const selectProductNameFromDataStorage = (state: RootState) => {
  return state.dataStorageNew.productName;
};

/**
 * Adjust whenever adding a new action.
 */
export type DataActionTypes = ReturnType<typeof setDataStorageNew> | ReturnType<typeof resetDataStorageNew>;

/**
 * - This store is reflection of data storage object 'data.custom' field.
 * - This store should not be used for anything prior customer details page.
 * - This store should only keep values indispensable for the process that are either impossible
 * or hard to het from Miles at stages they are needed.
 * - As soon as `isCreditApplicationDataReady` is true, most of this store data is populated and usable.
 */
const initialState = {
  quoteId: undefined as Optional<string>,
  milesCustomerId: undefined as Optional<string>,

  bankAccountOwner: undefined as Optional<string>,
  openingDate: undefined as Optional<string>,
  iban: undefined as Optional<string>,
  bic: undefined as Optional<string>,

  productName: undefined as Optional<string>,
  lastVisitedLocation: undefined as Optional<string>,

  saveAndContinueMobilePhoneNumber: undefined as Optional<string>,
  saveAndContinueMobilePhoneCountryCode: undefined as Optional<string>,
  saveAndContinueEmail: undefined as Optional<string>,
  ident: {
    mainCustomer: {} as IdentData,
    coCustomer: {} as IdentData | undefined,
  },
  creditApplicationId: undefined as Optional<string>,
  creditApplicationStakeholders: {
    directorContactId: undefined as Optional<string>,
    signatoryContactId: undefined as Optional<string>,
  },
};

export type DataStorageCustomDataType = typeof initialState;
export type DataStorageUpdateResponse = { custom: DataStorageCustomDataType };
export type DataStorageRequest = { custom: Partial<DataStorageCustomDataType> };
export type CreditApplicantCustomerData = CreditIntegration.Schemas.GetApplicantDetailsCustomerData['customerData'];
export type IdentData = {
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  email: string;
  telephoneNumber: string;
};

export const dataStorageNewReducer = (state = initialState, action: DataActionTypes): DataStorageCustomDataType => {
  switch (action.type) {
    case 'dataStorageNew//SET_DATA_STORAGE_NEW':
      return {
        ...state,
        ...action.payload,
      };
    case 'dataStorageNew//RESET_DATA_STORAGE_NEW':
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
